const animateNavigation = function(){
  let listItems = [];
  
  const _init = function(){
     _animateItems();
  };

  const _animateItems = function(){
    let index = 0;
    
    [].map.call(document.getElementsByClassName('m-mobile-nav__item'), function(item){
      index ++;
      item.style.transitionDelay = '0.'+index+'s';
      item.classList.add('visible');
    });
  };

  const _resetItems = function(){
    [].map.call(document.getElementsByClassName('m-mobile-nav__item'), function(item){
      item.style.transitionDelay = '0s';
      item.classList.remove('visible');
    });
  };

  return {
    init: _init,
    reset: _resetItems
  }
}();

export default animateNavigation;


// WEBPACK FOOTER //
// ./resources/assets/js/partials/MobileNavAnimations.js